// extracted by mini-css-extract-plugin
export var gif = "_mj-0";